function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 35 35",
  fill: "none"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 32.53c8.3 0 15.03-6.728 15.03-15.03 0-8.3-6.73-15.03-15.03-15.03C9.2 2.47 2.47 9.2 2.47 17.5c0 8.302 6.73 15.03 15.03 15.03zm0 2.47C27.164 35 35 27.167 35 17.5 35 7.836 27.164 0 17.5 0S0 7.836 0 17.5C0 27.167 7.836 35 17.5 35z",
  fill: "#354147"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.48 13.672a1.39 1.39 0 00-1.39 1.39h-2.47a3.86 3.86 0 017.72 0h-2.468a1.39 1.39 0 00-1.392-1.39zm-11.814 0a1.39 1.39 0 00-1.39 1.39h-2.47a3.86 3.86 0 017.72 0h-2.47a1.39 1.39 0 00-1.39-1.39zm-1.89 6.182c0-.682.553-1.235 1.235-1.235h13.127c.682 0 1.235.552 1.235 1.234 0 4.29-3.506 7.797-7.797 7.797-4.293 0-7.8-3.505-7.8-7.796zm2.616 1.235c.562 2.337 2.68 4.09 5.183 4.09 2.502 0 4.62-1.753 5.18-4.09H12.393z",
  fill: "#354147"
})));